export const GRAPH_SERVER_URL =
  process.env.REACT_APP_GRAPH_SERVER_URL ||
  "https://brokeandabroad-dev-backend.6lgx.com/query";
export const STRIPE_DASHBOARD_URL =
  process.env.REACT_APP_STRIPE_DASHBOARD_URL ||
  "https://dashboard.stripe.com/test/customers";
